import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FirebaseAuthService } from "../../noizu/services/firebase-auth.service";
import { SubscriptionsEntity } from "../../entities/subscriptions.entity";
import { AppengineRepo } from "../appengine.repo";

@Injectable()
export class SubscriptionsRepo extends AppengineRepo {
  public _kind = "subscription-definition";
  public _singular = "subscription-definition";

  constructor(
    @Inject(HttpClient) client: HttpClient,
    @Inject(FirebaseAuthService) auth: FirebaseAuthService
  ) {
    super(client, auth);
  }

  entity(record) {
    return new SubscriptionsEntity(this.client, this.auth, record);
  }
}
